/**
 * DomainSection Component
 *
 * Displays domain information including domain name, registrant organization,
 * and optional links to domain origination and discovered capability.
 */

import * as psl from 'psl';
import { Link, To } from 'react-router';

import { OverflowText } from '@/components/OverflowText';

export interface DomainInfo {
  name: string;
  registrantOrg?: string;
  domainOrigination?: To;
  discoveredCapability?: string;
}

export interface DomainSectionProps {
  domain: DomainInfo;
}

export function DomainSection({ domain }: DomainSectionProps) {
  return (
    <div className="flex w-full gap-6 text-nowrap">
      <div className="flex shrink-1 flex-col gap-1 overflow-hidden">
        <h3 className="text-lg font-bold">Domain</h3>
        <OverflowText text={psl.get(domain.name) || ''} />
      </div>
      {domain.registrantOrg && (
        <div className="flex shrink-1 flex-col gap-1 overflow-hidden">
          <h3 className="text-lg font-bold">Registrant Org</h3>
          <OverflowText text={domain.registrantOrg} />
        </div>
      )}
      {(domain.discoveredCapability || domain?.domainOrigination) && (
        <div className="ml-auto flex shrink-1 flex-col gap-1 overflow-hidden">
          {domain?.domainOrigination && (
            <Link className="text-sm underline" to={domain?.domainOrigination}>
              Domain Origination
            </Link>
          )}
          {domain.discoveredCapability && (
            <p className="truncate text-sm">{domain.discoveredCapability}</p>
          )}
        </div>
      )}
    </div>
  );
}
